module.exports = __webpack_public_path__ + "media/images/copy_ic-69c7e31357db24a1dcc2791ef57d4880.svg";